import { Spinner } from '@blueprintjs/core'
import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'

function LoadingCoverPixel () {
  return (
    <div css={css`position: absolute; height: 100%; width: 100%; background-color: var(--baseColor);`}>
      <div className={'pixelFont'} css={css`top: calc(40% - 50px); left: calc(50% - 50px); position: absolute; font-size: 4em;`}>Loading</div>
    </div>
  )
}

export default LoadingCoverPixel
